import React from 'react';
import { useSelector } from 'react-redux';
import { IRootReducerState } from 'store/store';
import { Overlay, OverlayText } from './OverlayProvider.styled';
import { useTranslation } from 'react-i18next';
import Loader from 'components/Loader/Loader';
import { useIsMutating } from 'react-query';
import { ReactMutationKeys } from 'services/api/reactMutationKeys';

interface IOverlayProviderProps {
  children: React.ReactNode;
}

const OverlayProvider = ({ children }: IOverlayProviderProps) => {
  const { t } = useTranslation();
  const queryRequestStatus = useSelector(
    (state: IRootReducerState) => state.modelInfo.queryStatus
  );
  const isSubmitConfigurationLoading = useIsMutating({
    mutationKey: ReactMutationKeys.SUBMIT_CONFIGURATION_WITH_WEBHOOK,
  });

  const isAddToCartLoading = useIsMutating({
    mutationKey: ReactMutationKeys.ADD_TO_SHOPPING_CART,
  });

  // A submission on its way for over a minute (a large one to NAV takes up to
  // five): it is still running, and must not be submitted again.
  const submissionIsSlow = useSelector(
    (state: IRootReducerState) => state.submitConfigurationInfo.submissionIsSlow
  );

  return (
    <>
      {queryRequestStatus.attempt ||
      isSubmitConfigurationLoading ||
      isAddToCartLoading ? (
        <Overlay onClick={() => console.log('overlay clicked')}>
          <Loader pwId={'configure-loader'} />
          {isSubmitConfigurationLoading && submissionIsSlow ? (
            <OverlayText data-testid="submission-slow">
              {t(
                'Still sending. This can take a few minutes; please keep this page open.'
              )}
            </OverlayText>
          ) : null}
        </Overlay>
      ) : null}

      {children}
    </>
  );
};

export default OverlayProvider;
